import script from "./section-header.vue?vue&type=script&lang=tsx"
export * from "./section-header.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__